import { render, staticRenderFns } from "./ProductSpecsView.vue?vue&type=template&id=67ae5c58"
import script from "./ProductSpecsView.vue?vue&type=script&lang=js"
export * from "./ProductSpecsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ae5c58')) {
      api.createRecord('67ae5c58', component.options)
    } else {
      api.reload('67ae5c58', component.options)
    }
    module.hot.accept("./ProductSpecsView.vue?vue&type=template&id=67ae5c58", function () {
      api.rerender('67ae5c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ProductSpecsView.vue"
export default component.exports